import React from "react";
import { AlertTriangle, X } from "lucide-react";
import "./ApprovalTeamsList/DeleteApprovalTeamModal.css";

export default function DeleteGeofenceModal({
  open,
  isDeleting,
  error,
  onClose,
  onConfirm,
}) {
  if (!open) return null;

  return (
    <div className="jfm-overlay" onClick={isDeleting ? undefined : onClose}>
      <div
        className="jfm-container dtm-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="dtm-header">
          <div className="dtm-header-icon">
            <AlertTriangle size={20} />
          </div>
          <div>
            <h3 className="dtm-header-title">Delete Location Geofence</h3>
            <p className="dtm-header-subtitle">This action cannot be undone</p>
          </div>
          <button
            className="jfm-close"
            onClick={onClose}
            disabled={isDeleting}
            style={{ marginLeft: "auto" }}
          >
            <X size={18} />
          </button>
        </div>

        <div className="dtm-body">
          <p className="dtm-prompt">
            Are you sure you want to delete this location geofence?
          </p>
        </div>

        {error && <div className="jfm-error">{error}</div>}

        <div className="jfm-footer">
          <div />
          <div className="jfm-footer-actions">
            <button
              className="jfm-cancel"
              onClick={onClose}
              disabled={isDeleting}
            >
              Cancel
            </button>
            <button
              className="dtm-delete-btn"
              onClick={onConfirm}
              disabled={isDeleting}
            >
              {isDeleting ? "Deleting..." : "Delete Geofence"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
